// Generated TypeScript interfaces for pay_periods

export enum PayPeriodID {
  WEEKLY = 1,
  MONTHLY = 2
}

